import { Component, Mixins, Watch, Ref } from 'vue-property-decorator';
import { State, Action, Mutation } from 'vuex-class';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import { Route } from 'vue-router';
import AppAflossenHypotheekdeelInfoVue from './info/AppAflossenHypotheekdeelInfo.vue';
import AppAflossenHypotheekdeelEditVue from './edit/AppAflossenHypotheekdeelEdit.vue';
import { IAflosschemas } from '@/model/IAflosschemas';
import { IGetAflosschemasRequest } from '@/store/AppAflosschemasDataModule';
import AppAflossenHypotheekdeelSchemasVue from './schemas/AppAflossenHypotheekdeelSchemas.vue';
import AppAflossenHypotheekdeelEdit from './edit/AppAflossenHypotheekdeelEdit';
import { appBetalingenService } from '@/services/appBetalingenService';
import AppAflossenHypotheekdeelExecuteVue from './execute/AppAflossenHypotheekdeelExecute.vue';
import { AppHypotheekMixin } from '../../mixins/AppHypotheekMixin';

@Component({
  components: {
    'app-aflossen-hypotheekdeel-info': AppAflossenHypotheekdeelInfoVue,
    'app-aflossen-hypotheekdeel-edit': AppAflossenHypotheekdeelEditVue,
    'app-aflossen-hypotheekdeel-schemas': AppAflossenHypotheekdeelSchemasVue,
    'app-aflossen-hypotheekdeel-execute': AppAflossenHypotheekdeelExecuteVue
  },
  validations: {}
})
export default class AppAflossenHypotheekdeel extends Mixins(AppFiltersMixin, AppHypotheekMixin) {
  public data: {
    aflossing?: number;
  } = {
    aflossing: undefined
  };
  public calculating = false;
  @State(state => state.aflosschemas)
  public aflosschemas!: IAflosschemas;
  public betalingMislukt = false;
  private enteredFromList = false;
  private delayCalculate: any;
  @Action('aflosschemas/reset')
  private reset!: () => void;
  @Action('aflosschemas/getAflosschemas')
  private getAflosschemas!: (args: IGetAflosschemasRequest) => Promise<IAflosschemas>;
  @Ref('aflossing')
  public aflossing!: AppAflossenHypotheekdeelEdit;

  @Mutation('hypotheken/selectCurrentHypotheekdeelnummer')
  private selectCurrentHypotheekdeelnummer!: (hypotheekdeelnummer: string) => {};

  created() {
    this.reset();
  }

  goBack(): void {
    this.$router.push(this.enteredFromList ? { name: 'aflossen-list' } : { name: 'hypotheek' });
  }

  get showAflosschemas(): boolean {
    return !!this.aflosschemas.loaded && !this.calculating;
  }

  @Watch('data.aflossing')
  private watchAflossing() {
    Promise.resolve().then(() => {
      this.calculateAflosschemas();
    });
  }

  private calculateAflosschemas() {
    if (this.delayCalculate) {
      clearTimeout(this.delayCalculate);
    }

    this.calculating = !this.aflossing.$v.$invalid;
    const delay = (this.delayCalculate = setTimeout(() => {
      if (this.calculating) {
        const endCalculate = () => {
          if (this.delayCalculate === delay) {
            this.delayCalculate = undefined;
            this.calculating = false;
          }
        };
        if (this.hypotheek && this.currentHypotheekdeel && this.data.aflossing) {
          this.getAflosschemas({
            hypotheeknummer: this.hypotheek.id,
            hypotheekdeelnummer: this.currentHypotheekdeel.hypotheeknummer,
            aflossingsbedrag: this.data.aflossing
          }).then(() => {
            endCalculate();
          });
        } else {
          endCalculate();
        }
        this.aflossing.reset();
      } else {
        this.aflossing.touch();
        if (this.aflosschemas) {
          // hide previously calculated aflosschemas
          this.aflosschemas.loaded = false;
        }
      }
    }, 2000));
  }

  pay(): void {
    if (this.hypotheek && this.currentHypotheekdeel && this.data.aflossing) {
      this.betalingMislukt = false;
      // this.paying = true;
      appBetalingenService
        .addBetaling(this.hypotheek.id, this.currentHypotheekdeel.hypotheeknummer, this.data.aflossing)
        .then(data => {
          window.location.href = data.paymentProviderRedirectUri;
        })
        .catch(() => {
          this.betalingMislukt = true;
        });
    }
  }

  beforeRouteEnter(to: Route, from: Route, next: Function) {
    next((vm: AppAflossenHypotheekdeel) => {
      vm.enteredFromList = to.query.from === 'list';
    });
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    this.selectCurrentHypotheekdeelnummer('');
    next();
  }
}
